import AX from 'axios';
import { getTokens, clearLocalStorage, setTokens } from '../helpers/localStorage';
import apiConfig from '../_config/config';
import mockAxios from '../helpers/mockAxios';

const axios = AX.create();

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  isRefreshing = false;
  failedQueue = [];
};

// eslint-disable-next-line
const getNewToken = async () => {
  const tokens = getTokens();
  try {
    const response = await axios.post(apiConfig.api.api_url + apiConfig.api.auth.refresh_token, {
      refresh_token: tokens ? tokens.refresh_token : ''
    });
    setTokens(response.data);
    return response.data;
  } catch (e) {
    console.dir(e);
  }
};

axios.interceptors.request.use(
  async config => {
    const newConf = { ...config };
    const tokens = getTokens();
    newConf.headers.Authorization = `Bearer ${tokens ? tokens.access_token : ''}`;
    return newConf;
  },
  error => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const origConf = error.config;
    if (error.response.status === 401) {
      if (!origConf.isNextTry) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(accessToken => {
              axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
              return axios(origConf);
            })
            .catch(err => {
              return err;
            });
        }
        origConf.isNextTry = true;
        isRefreshing = true;
        try {
          const { access_token: accessToken } = await getNewToken();
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
          processQueue(null, accessToken);
          return axios(origConf);
        } catch (e) {
          clearLocalStorage();
          window.open('/login', '_self');
        }
      }
      clearLocalStorage();
      window.open('/login', '_self');
    }
    return Promise.reject(error);
  }
);

mockAxios(axios);

export default axios;
